<template>
<!-- 
    hover状态文字提示组件
 -->
    <el-popover
        placement="top"
        :width="width"
        trigger="hover"
        :content="content"
    >
        <i class="el-icon-question" slot="reference"></i>
    </el-popover>
</template>
<script>
export default {
    props: ['content'],
    data() {
        return {
            width: '300'
        }
    }
};
</script>
<style lang="less" scope>
    
</style>